module.exports = __webpack_public_path__ + "static/media/ic_add_circle_outline_selected.8c3abc22.svg";